import React, { useCallback } from "react";
import {
  DndContext,
  DragEndEvent,
  DragOverlay,
  useDroppable,
} from "@dnd-kit/core";
import { Query, RANGE_FILTERS } from "types";
import {
  getFilterIcon,
  getOperatorTitle,
  isSignOperator,
} from "helpers/utility/queryFilterHelpers";
import { isCustomMetadata } from "helpers/utility/customMetadataHelpers";
import QueryTab from "views/components/QueryTab";

// Hook for droppable functionality
export const useDroppableRow = (dropZoneId: string = "default-drop-zone") => {
  const { isOver, setNodeRef } = useDroppable({
    id: dropZoneId,
  });

  const combinedRef = useCallback(
    (node: HTMLDivElement | null) => {
      setNodeRef(node);
    },
    [setNodeRef],
  );

  return { isOver, combinedRef };
};

// Drag and Drop Context Wrapper
export const DragAndDropProvider = ({
  children,
  activeQuery,
  handleDragStart,
  handleDragEnd,
  sensors,
}: {
  children: React.ReactNode;
  activeQuery: Query | null;
  handleDragStart: (event: any) => void;
  handleDragEnd: (event: DragEndEvent) => void;
  sensors: any;
}) => {
  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      data-testid="dnd-context"
    >
      {children}
      <DragOverlay data-testid="drag-overlay">
        {activeQuery ? (
          <QueryTab
            icon={getFilterIcon(activeQuery.type)}
            id={activeQuery.id}
            labels={activeQuery.values}
            isRange={
              !isCustomMetadata(activeQuery.type) &&
              RANGE_FILTERS.includes(activeQuery.type)
            }
            noColon={isSignOperator(
              getOperatorTitle(activeQuery.operator, activeQuery.type),
            )}
            type={activeQuery.type}
            operator={getOperatorTitle(activeQuery.operator, activeQuery.type)}
            subType={activeQuery.subType}
            onRemove={() => {}}
            image={activeQuery.image}
            interactive={false}
            data-testid={`drag-overlay-query-tab-${activeQuery.id}`}
          />
        ) : null}
      </DragOverlay>
    </DndContext>
  );
};
